import { Menu } from "@grapecity/wijmo.input";
import { CellType, GroupRow } from "@grapecity/wijmo.grid";
import {
  CollectionViewGroup,
  PropertyGroupDescription,
} from "@grapecity/wijmo";
import { FlexGridXlsxConverter } from "@grapecity/wijmo.grid.xlsx";

// Wijmo Grid 내부 Menu Class
export class E3WijmoGridContextMenu {
  /*-----------------------------
   * 초기셋팅
   *---------------------------*/
  constructor(grid, fileName) {
    // fileName 재정의 - fileName_년월일
    const d = new Date();
    fileName =
      fileName + "_" + d.getFullYear() + (d.getMonth() + 1) + d.getDate();

    let host = grid.hostElement,
      menu = this._buildMenu(grid, fileName);

    if (host) {
      host.addEventListener(
        "contextmenu",
        (e) => {
          // select the cell/column that was clicked
          let sel = grid.selection,
            ht = grid.hitTest(e),
            row = ht.getRow();
          // cancel grid header
          if (ht.cellType == CellType.ColumnHeader) {
            e.preventDefault();
            return;
          }

          switch (ht.panel) {
            case grid.cells:
              let colIndex = ht.col;
              // if this is a group header, select the group column
              if (
                row instanceof GroupRow &&
                row.dataItem instanceof CollectionViewGroup
              ) {
                let gd = row.dataItem.groupDescription;
                if (gd instanceof PropertyGroupDescription) {
                  let col = grid.getColumn(gd.propertyName);
                  if (col && col.index > -1) {
                    colIndex = col.index;
                  }
                }
              }
              grid.select(ht.row, colIndex);
              break;
            case grid.columnHeaders:
              grid.select(sel.row, ht.col);
              break;
            case grid.rowHeaders:
              grid.select(ht.row, sel.col);
              break;
            default:
              return; // invalid panel
          }
          // show the menu for the current column
          if (grid.selection.col > -1) {
            e.preventDefault(); // cancel the browser's default menu
            menu.show(e); // and show ours
          }
        },
        true
      );
    }
  }
  _buildMenu(grid, fileName) {
    let menu = new Menu(document.createElement("div"), {
      owner: grid.hostElement,
      displayMemberPath: "header",
      subItemsPath: "items",
      commandParameterPath: "cmd",
      dropDownCssClass: "ctx-menu",
      openOnHover: true,
      closeOnLeave: true,
      itemsSource: [
        {
          header: "Export",
          items: [
            { header: "XLSX", cmd: "X_XLSX" },
            { header: "XLSX(Merge 제거)", cmd: "X_XLSX_NEW" },
          ],
        },
      ],
      command: {
        /*// enable/disable menu commands
        canExecuteCommand: (cmd) => {
 
        },*/
        // execute menu commands
        executeCommand: (cmd) => {
          let view = grid.collectionView,
            cols = grid.columns,
            col = cols[grid.selection.col],
            sd = view?.sortDescriptions,
            gd = view?.groupDescriptions;

          let exportFormatItem = (args) => {
            let p = args.panel,
              row = args.row,
              col = args.col,
              xlsxCell = args.xlsxCell,
              cell;

            // cell 상하 가운데 정렬
            xlsxCell.style.vAlign = 1;
            if (p.cellType === CellType.Cell) {
              if (
                p.columns[col].name === "excelFormat" &&
                p.rows[row] instanceof GroupRow
              ) {
                // 그리드에 보여지는 값으로 엑셀 값 출력
                cell = args.getFormattedCell();
                xlsxCell.value = cell.textContent.trim();
              }
            }
          };

          switch (cmd) {
            // export
            /*case 'X_CSV':
              let rng = new CellRange(0, 0, grid.rows.length - 1, grid.columns.length - 1),
                csv = grid.getClipString(rng, ClipStringOptions.CSV, true, false);
              saveFile(csv, fileName + '.csv');
              break;
              */
            case "X_XLSX": // xlsx 엑셀
              FlexGridXlsxConverter.saveAsync(
                grid,
                {
                  includeColumns: function (column) {
                    return (
                      column.binding !== "ROW_CHECK" &&
                      column.binding !== "ROW_STATUS"
                    );
                  },
                  formatItem: exportFormatItem,
                },
                fileName + ".xlsx"
              );
              break;
            case "X_XLSX_NEW": // xlsx 엑셀 (merge 제거)
              const mergingIdx = [];
              const mergeState = grid.mergeManager;
              grid.mergeManager = null;

              grid.columns.forEach((x, idx) => {
                if (x.allowMerging) mergingIdx.push(idx);
                x.allowMerging = false;
              });

              FlexGridXlsxConverter.saveAsync(
                grid,
                {
                  includeColumns: function (column) {
                    return (
                      column.binding !== "ROW_CHECK" &&
                      column.binding !== "ROW_STATUS"
                    );
                  },
                },
                fileName + ".xlsx"
              );

              grid.mergeManager = mergeState;
              grid.columns.forEach((x, idx) => {
                if (mergingIdx.includes(idx)) x.allowMerging = true;
              });
              break;
            /*
            case 'X_PDF':
              FlexGridPdfConverter.export(grid, fileName + '.pdf', {
                maxPages: 10,
                scaleMode: ScaleMode.PageWidth,
                documentOptions: {
                  compress: true,
                  header: { declarative: { text: '\t&[Page] of &[Pages]' } },
                  footer: { declarative: { text: '\t&[Page] of &[Pages]' } },
                  info: { author: 'GrapeCity', title: 'FlexGrid' },
                },
                styles: {
                  cellStyle: { backgroundColor: '#ffffff', borderColor: '#c6c6c6' },
                  altCellStyle: { backgroundColor: '#f9f9f9' },
                  groupCellStyle: { backgroundColor: '#dddddd' },
                  headerCellStyle: { backgroundColor: '#eaeaea' },
                },
              });
              break;*/
          }
          // restore focus to active grid cell (TFS 439964)
          grid.refresh();
          let sel = grid.selection,
            cell = grid.cells.getCellElement(sel.row, sel.col);
          if (cell) {
            cell.focus();
          }
        },
      },
    });
    // done
    return menu;
  }
}
